import {
  Alert,
  Typography
} from '@mui/material';
import { useLoadOptions } from 'src/hooks/useLoadOptions';
import CardActions from 'src/pages/sistema/components/CardActions';
import { EntityWithIdFields, QueryStatus } from 'src/types';
import { useLCLSLimiteTipos } from '../hooks/useLCLSCache';
import { useLCLSCuentaLimites } from '../hooks/useLCLSCuentaLimites';
import { OperacionLCLS } from '../types/types';
import { CuentaLimitesCard } from './OperacionLCLSCuentaCard';

interface SeccionLCLSLimitesTablaProps {
  operacion: OperacionLCLS;
  permiteEditar: boolean;
}

const SeccionLCLSLimitesTabla = ({ operacion, permiteEditar }: SeccionLCLSLimitesTablaProps) => {
  const { cuentas, status, refetch } = useLCLSCuentaLimites(operacion[EntityWithIdFields.Id]);

  const limitesTipos = useLCLSLimiteTipos();
  const loadLimitesOptions = useLoadOptions({
    data: limitesTipos.limiteTipos,
    loading: limitesTipos.isLoading,
    isError: limitesTipos.isError,
    error: limitesTipos.error,
  });

  if (status === QueryStatus.Loading) {
    return <Typography>Cargando límites...</Typography>;
  }

  if (status === QueryStatus.Error || !cuentas) {
    return <Alert severity="error">No se pudieron cargar los límites de la operación.</Alert>;
  }

  return (
    <CardActions title='Límites de la Operación' icon='mdi:currency-usd' colapsable>
      {cuentas.map((cuenta) => (
        <CuentaLimitesCard
          key={cuenta.id}
          cuenta={cuenta}
          operacion={operacion}
          loadLimitesOptions={loadLimitesOptions}
          refetch={refetch}
          permiteEditar={permiteEditar} // dentro de cada limite en cada cuenta en OperacionLCLSLimiteFila hay un bitPermiteEditar propio de cada limite que tambien debe ser true para que se pueda editar
        />
      ))}
    </CardActions>
  );
}

export default SeccionLCLSLimitesTabla;
